export function BugConnexion () {

  return (
    <div className="alert danger">
    	<br/>
    	<span style={{fontSize:'2em'}} >😲</span> Oops ! <br/> 
    	Une erreur de connexion est survenue.
    	<br/>
    	Veuillez actualiser la page en cliquant sur le bouton suivant :<br/><br/>
    	<buton className='btn standard' onClick={()=>window.location.reload()}>Actualiser la page</buton>
        <br/><br/><br/>
    </div>
  );
}